<template>
    <!-- 公用组件  备注-->
  <div class="SelectOne">
    <span class="label_name1">{{name}}</span>
    <!-- <i class="el-icon-question icon_sty"  v-if="isquestion"></i> -->
    <el-select v-model="value1" placeholder="请选择" size="mini" class="select_sty" @change="sendData">
      <el-option v-for="(item,index) in options" :key="index" :label="item.lable" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
  export default {
    name:"SelectOne",
    data(){
        return{
          value1:this.value
        }
    },
    methods:{
        sendData(value){
            // console.log(value);
          let obj = {};
          obj = this.options.find((item)=>{
            return item.id === value;
          });
          this.$emit('valchaneg',obj);
        }
    },
    props:{
        name: {
            type: String,
            default: "客户"
        },
        options:Array,
        value:{
            type: String,
        }
    }

  }
</script>

<style lang="less">
.SelectOne{
    width: 100%;
    height: 30px;
    display: -webkit-box !important;
	  display: box !important;
    position:relative;
    -webkit-box-align:center;
    box-align:center;
    color: #666;
    border: 1px solid #d6e2ed;
    border-radius: 5px;
    padding: 0 5px;
    font-size: 12px;
    box-sizing: border-box;
    .label_name{
      height: 100%;
      line-height: 28px;
      font-size: 12px;
      color: inherit;
      font-weight: bold;
    }
    .select_sty{
        position:relative;
        -webkit-box-flex: 1; 
        box-flex: 1;
        display: block;
        height: 100%;
        margin-left: 5px;
    }
    .el-input__inner{
      padding: 0;
      height: 28px;
    }
    .el-input__inner:hover {
        border-color: #fff;
    }
    .el-select .el-input__inner:focus {
        border-color: #fff;
        // outline: 0;
    }
    .el-select .el-input.is-focus .el-input__inner {
        border-color: #fff;
    }
    .el-input__inner,.el-input__inner:hover {
        border-color: #fff;
    }
    .el-input__inner,.el-input__inner::selection {
        border-color: #fff;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/SelectOne/SelectOne.vue